import { AskForAccount } from '../api/api';
import { SIGN_UP_BUSINESS_SUCCESS, SIGN_UP_BUSINESS_FAILURE, RESET_SIGN_UP_BUSINESS } from '../constants/action_types';
import {isEmpty} from "lodash";

const signUpBusinessSuccess = () => ({
    type: SIGN_UP_BUSINESS_SUCCESS,
});

const signUpBusinessFailure = () => ({
    type: SIGN_UP_BUSINESS_FAILURE
});

const resetSignUpBusiness = () => ({
    type: RESET_SIGN_UP_BUSINESS
});

const requestAccountBusiness = (data) => dispatch => {
    
    return AskForAccount(data)
    .then(res => {
        if (!res.ok || !isEmpty(res.body.errors)) {
            return dispatch(signUpBusinessFailure());;
        } else {
            return dispatch(signUpBusinessSuccess());
        }
    })
};

export {
    resetSignUpBusiness,
    requestAccountBusiness
};
